<template>
  <div>
    <Head :title="`Edit Booking: ${form.id}`" />
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link href="/agent-bookings">Bookings</Link></li>
        <li class="breadcrumb-item active" aria-current="page">Edit Booking {{ form.id }}</li>
      </ol>
    </nav>

    <trashed-message v-if="bookings.deleted_at" class="mb-6" @restore="restore">This booking has been deleted. </trashed-message>

    <div class="actions-bar content-box mb-3">
      <button type="button" class="btn btn-primary" @click="downloadPdf()">Download PDF</button>
    </div>

    <div class="row">
      <div class="col-md-6">
        <h1 class="h2">
          Edit Booking: {{ form.id }}
        </h1>
        <div class="content-box mb-3">
          <div class="customer-details">
            <div class="mb-3">
              <label for="">Order Status</label>

              <select class="form-select" v-model="form.status" disabled>
                <option :value="null"></option>
                <option value="draft">Draft</option>
                <option value="request">Request</option>
                <option value="offer">Offer</option>
                <option value="reservation">Reservation</option>
                <option value="booked">Booked</option>
                <option value="cancelled">Cancelled</option>
              </select>
            </div>

            <h3>Customer details</h3>

            <div class="mb-3">
              <CustomerData :customer="selectedCustomer" />
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <h2>Journey Schedule</h2>
        <div class="content-box mb-3">

          <div class="journeys mb-3">
            <JourneyCard class="" v-for="(journey, index) in form.journeys" :key="index" :form="form" :journey="journey" :types="types" :operators="operators" :airports="airports" :index="index" />
            <AddJourneyModal :form="form" :types="types" :operators="operators" :airports="airports" />
          </div>
        </div>

        <h3>Itinerary - Connection Flight Information</h3>
        <div class="content-box mb-3">
          <div class="itinerary">

            <div class="row">
              <div class="col-md-6">
                <h4>Inbound</h4>
                <div class="row mb-2">
                  <label for="staticEmail" class="col-sm-5 col-form-label">Airline Name</label>
                  <div class="col-sm-7">
                    <input type="text" class="form-control" id="" v-model="form.itinerary.inbound.airline">
                  </div>
                </div>

                <div class="row mb-2">
                  <label for="staticEmail" class="col-sm-5 col-form-label">Flight Number</label>
                  <div class="col-sm-7">
                    <input type="text" class="form-control" id="" v-model="form.itinerary.inbound.flight_number">
                  </div>
                </div>

                <div class="row mb-2">
                  <label for="staticEmail" class="col-sm-5 col-form-label">Date</label>
                  <div class="col-sm-7">
                    <input type="text" class="form-control" id="" v-model="form.itinerary.inbound.date">
                  </div>
                </div>

                <div class="row mb-2">
                  <label for="staticEmail" class="col-sm-5 col-form-label">Time</label>
                  <div class="col-sm-7">
                    <input type="text" class="form-control" id="" v-model="form.itinerary.inbound.time">
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <h4>Outbound</h4>
                <div class="row mb-2">
                  <label for="staticEmail" class="col-sm-5 col-form-label">Airline Name</label>
                  <div class="col-sm-7">
                    <input type="text" class="form-control" id="" v-model="form.itinerary.outbound.airline">
                  </div>
                </div>

                <div class="row mb-2">
                  <label for="staticEmail" class="col-sm-5 col-form-label">Flight Number</label>
                  <div class="col-sm-7">
                    <input type="text" class="form-control" id="" v-model="form.itinerary.outbound.flight_number">
                  </div>
                </div>

                <div class="row mb-2">
                  <label for="staticEmail" class="col-sm-5 col-form-label">Date</label>
                  <div class="col-sm-7">
                    <input type="text" class="form-control" id="" v-model="form.itinerary.outbound.date">
                  </div>
                </div>

                <div class="row mb-2">
                  <label for="staticEmail" class="col-sm-5 col-form-label">Time</label>
                  <div class="col-sm-7">
                    <input type="text" class="form-control" id="" v-model="form.itinerary.outbound.time">
                  </div>
                </div>
              </div>
            </div>

            <div class="form-check form-switch mt-3">
              <input class="form-check-input" type="checkbox" role="switch" id="show_on_booking" v-model="form.show_itinerary">
              <label class="form-check-label" for="show_on_booking">Show on Booking</label>
            </div>
          </div>
        </div>

        <h3>Order Comment</h3>
        <div class="content-box mb-3">
          <div class="itinerary">
            <editor
              api-key="wk0iduiwkjwjr9x9gm8yfkr7v8y5ltp7xab2qkdhgoupdzdd"
              v-model="form.comment"
              :init="{
                height: 300,
                menubar: false,
                toolbar:
                  'undo redo | bold italic'
              }"
            />

            <div class="form-check form-switch mt-3">
              <input class="form-check-input" type="checkbox" role="switch" id="show_comment" v-model="form.show_comment">
              <label class="form-check-label" for="show_comment">Show on Booking</label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content-box mb-3">
      <div class="mb-3" v-if="selectedCustomer.id">
        <h3>Add passengers to booking</h3>
        <div class="passengers-list exists mb-3" v-if="customerPassengers.length">
          <div class="existing rounded">
            <p class="lead">Known passengers</p>
            <div class="add-passenger">
              <div class="btn btn-dark btn-sm btn-passenger" v-for="(passenger, index) in customerPassengers" :key="index" @click="existingPassenger(passenger)" :class="passengerClasses(passenger)">
                {{ passenger.given_names }} {{ passenger.surname }}
              </div>
            </div>
          </div>
        </div>
        <div class="passengers-list new">

          <div class="alert alert-info" v-if="!form.passengers.length">
            No passengers found.
          </div>

          <div class="row">
            <div class="col-md-4" v-for="(passenger, index) in form.passengers" :key="index">
              <PassengerCard :form="form" :passenger="passenger" :passengers="customerPassengers" :customers="selectedCustomer" :index="index" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content-box">
      <form @submit.prevent="update" >
        <OrderTableView :form="form" :order="order" :products="products" />

        <div class="mb-3">
          <label for="" class="fw-bold">Internal Comment</label>
          <editor
            api-key="wk0iduiwkjwjr9x9gm8yfkr7v8y5ltp7xab2qkdhgoupdzdd"
            v-model="form.intern_comment"
            :init="{
              height: 300,
              menubar: false,
              toolbar:
                'undo redo | bold italic'
            }"
          />
        </div>

        <div class="actions-toolbar d-flex justify-content-between">
          <!-- <loading-button v-if="bookings.status === 'offer'" :loading="form.processing" class="btn btn-primary" type="submit">Request Change</loading-button> -->
          <!-- <loading-button v-if="bookings.status === 'offer'" :loading="form.processing" class="btn btn-primary" type="button" @click="AcceptOffer()">Accept Offer</loading-button> -->
          <loading-button v-if="bookings.status === 'request'" :loading="form.processing" class="btn btn-primary" type="submit">Update Booking</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import axios from 'axios'
import Editor from '@tinymce/tinymce-vue'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import CustomerData from './../component/CustomerData'
import AddJourneyModal from './../component/AddJourneyModal'
import JourneyCard from './../component/JourneyCard.vue'
import PassengerCard from './../component/PassengerCard'
import PassengerModal from './../component/PassengerModal'
import EditPassengerModal from './../component/EditPassengerModal'
import OrderTableView from './../component/OrderTableView'

export default {
  components: {
    Head,
    Editor,
    Icon,
    Link,
    LoadingButton,
    SelectInput,
    TrashedMessage,
    CustomerData,
    AddJourneyModal,
    JourneyCard,
    PassengerModal,
    PassengerCard,
    EditPassengerModal,
    OrderTableView
  },
  layout: Layout,
  props: {
    bookings: Object,
    customers: Object,
    flights: Object,
    airports: Object,
    operators: Object,
    types: Object,
    products: Object,
    mail_templates: Object
  },
  remember: 'form',
  data() {
    return {
      drag: false,
      selectedCustomer: [],
      customerPassengers: [],
      form: this.$inertia.form({
        id: this.bookings.id,
        status: this.bookings.status,
        customers_id: this.bookings.customers_id,
        show_itinerary: this.bookings.show_itinerary,
        itinerary: this.bookings.itinerary,
        journeys: this.bookings.journeys,
        passengers: this.bookings.passengers,
        order_lines: this.bookings.order_lines,
        intern_comment: this.bookings.intern_comment,
        comment: this.bookings.comment,
        show_comment: this.bookings.show_comment,
        subtotal: this.bookings.subtotal,
        taxes: this.bookings.taxes,
        final_total: this.bookings.final_total
      })
    }
  },
  created() {
	  this.getCustomer();
  },
  computed: {
    auth() {
      return this.$page.props.auth
    }
  },
  methods: {
    update() {
      this.form.put(`/agent-bookings/${this.bookings.id}`)
    },
    AcceptOffer() {
      this.form.put(`/agent-bookings/${this.bookings.id}/accept`)
    },
    downloadPdf() {
      //this.$inertia.get(`/generate-pdf/${this.bookings.id}`)
      window.open(`/generate-pdf/${this.bookings.id}`, '_blank', 'noreferrer');
    },
    passengerClasses(passenger) {
      return {
        active: this.form.passengers.some(pass => pass['passport_number'] === passenger.passport_number),
        expired: Date.parse(passenger.passport_expire) - Date.parse(new Date()) < 0
      }
    },
    existingPassenger(passenger) {
      const checkPassport = this.form.passengers.find(element => {
        if (element.passport_number === passenger.passport_number) {
          return true;
        }
      })
      if (!checkPassport) {
        this.form.passengers.push(passenger);
      }
    },
    removePassenger(index) {
      this.form.passengers.splice(index, 1);
    },
    async getCustomer(event) {
      if (this.form.customers_id) {
        const getCustomer = await axios.get(`/customers/${this.form.customers_id}/get`)
        this.selectedCustomer = getCustomer.data[0];

        const getPassengers = await axios.get(`/passengers/${this.form.customers_id}/get`)
        this.customerPassengers = getPassengers.data;
      }
    }
  },
}
</script>
